// Wijzigingslog: wie zette welke taak / welk project wanneer op Afgerond (of een
// andere status). Gevuld door de tool zelf (taken-PATCH) en de Gripp-sync
// ('gripp-sync'); Airtable's eigen record-history toont voor tool-wijzigingen
// alleen de API-user, vandaar deze eigen log (Joris, 1 sep 2026).
import React, { useCallback, useEffect, useState } from 'react';
import {
  Box, Chip, CircularProgress, MenuItem, Stack, Table, TableBody, TableCell,
  TableHead, TableRow, TextField, Typography,
} from '@mui/material';
import { AI_ENGINE_URL } from '../../../utils/apiConfig';
import { authFetch } from '../../../utils/authHelpers';
import { leesJson, meldFout } from '../../../utils/apiFout';

export default function WijzigingsLog() {
  const [log, setLog] = useState(null);
  const [soort, setSoort] = useState('');
  const [zoek, setZoek] = useState('');

  const laad = useCallback(async () => {
    const params = new URLSearchParams({ limit: '300' });
    if (soort) params.set('entity_type', soort);
    if (zoek.trim()) params.set('q', zoek.trim());
    try {
      const r = await authFetch(`${AI_ENGINE_URL}/api/v1/airtable/status-log?${params}`);
      const d = await leesJson(r, 'Wijzigingslog laden');
      setLog(d.log || []);
    } catch (e) { meldFout(e, 'Wijzigingslog laden'); setLog([]); }
  }, [soort, zoek]);

  useEffect(() => {
    const t = setTimeout(laad, 300);
    return () => clearTimeout(t);
  }, [laad]);

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Statuswijzigingen via de tool en de Gripp-sync — wie, wanneer, van wat naar wat.
        Wijzigingen die rechtstreeks in Airtable gebeuren staan hier niet; die zie je in
        de record-history van Airtable zelf.
      </Typography>
      <Stack direction="row" spacing={1.5} sx={{ mb: 2 }}>
        <TextField select size="small" label="Soort" value={soort} onChange={(e) => setSoort(e.target.value)} sx={{ minWidth: 140 }}>
          <MenuItem value="">Alles</MenuItem>
          <MenuItem value="task">Taken</MenuItem>
          <MenuItem value="project">Projecten</MenuItem>
        </TextField>
        <TextField size="small" label="Zoek (naam, nummer, wie, status)" value={zoek}
          onChange={(e) => setZoek(e.target.value)} sx={{ minWidth: 280 }} />
      </Stack>
      {log === null ? <CircularProgress size={22} /> : log.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          Nog geen wijzigingen gelogd — de log loopt vanaf 1 september 2026.
        </Typography>
      ) : (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Wanneer</TableCell>
              <TableCell>Soort</TableCell>
              <TableCell>Wat</TableCell>
              <TableCell>Van → naar</TableCell>
              <TableCell>Door</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {log.map((r, i) => (
              <TableRow key={i} hover>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{(r.at || '').slice(0, 16).replace('T', ' ')}</TableCell>
                <TableCell><Chip size="small" label={r.entity_type === 'project' ? 'Project' : 'Taak'} /></TableCell>
                <TableCell sx={{ maxWidth: 340, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {r.entity_name || r.entity_id}
                </TableCell>
                <TableCell>{r.old_value || '—'} → <b>{r.new_value || '—'}</b></TableCell>
                <TableCell>{r.user_email === 'gripp-sync' ? '⚙️ Gripp-sync' : r.user_email || 'onbekend'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  );
}
